import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const BuildCache = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="M5.79688 5.22032C9.55091 4.92656 14.4492 4.92656 18.2032 5.22032C19.5342 5.32447 20.5956 6.31592 20.8455 7.59604C21.467 10.7795 21.8439 13.16 21.9607 15.812C22.0297 17.3778 20.838 18.6941 19.2819 18.7968C15.1741 19.0677 8.8259 19.0677 4.71817 18.7968C3.16204 18.6941 1.97034 17.3778 2.0393 15.812C2.15611 13.16 2.53306 10.7795 3.15454 7.59604C3.40445 6.31592 4.46586 5.32447 5.79688 5.22032ZM11.5 9V15.5H9.5V9H11.5ZM18.5 10.5V15.5H16.5V10.5H18.5ZM8 10.5V15.5H6V10.5H8ZM15 12.5V15.5H13V12.5H15Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default BuildCache;
